export const meta = {
  id: 'M02',
  slug: 'conheca-visao-360',
  title: 'Conheça a Visão 360 do Mentorado',
  description: 'Use a Visão 360 para entender o momento do mentorado antes de orientar ou conduzir uma Mentoria.',
  profile: 'mentor',
  category: 'visao-360',
  type: 'screen',
  status: 'published',
  order: 230,
  keywords: ['visão 360', 'mentorado', 'contexto', 'objetivo', 'progresso', 'evidências', 'mentoria'],
  previous: 'M01',
  next: 'M03',
  related: ['M07', 'M09', 'A03'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Conheça a Visão 360 do Mentorado

A Visão 360 reúne informações relevantes para você compreender o momento do mentorado antes de orientar, avaliar ou conduzir uma sessão.

## O que observar

Dependendo do que já existe para aquela pessoa, a visão pode reunir referências como:

- objetivo de desenvolvimento;
- Diagnóstico e competências;
- Plano;
- Jornada e Formações;
- metas e progresso;
- Evidências;
- Mentorias anteriores;
- atividade recente e itens que precisam de atenção.

## Como utilizar bem a tela

<Steps>
  <Step title="Comece pelo objetivo">
    Relembre onde o mentorado quer chegar e qual desenvolvimento está buscando.
  </Step>
  <Step title="Observe a evolução">
    Analise competências, Plano, Jornada, Formações, Evidências e progresso em conjunto.
  </Step>
  <Step title="Identifique o que merece atenção">
    Procure pontos que possam gerar uma conversa útil, uma orientação ou um Acordo na próxima Mentoria.
  </Step>
</Steps>

<Callout type="tip">
  A Visão 360 serve para gerar contexto, não para transformar a Mentoria em fiscalização. Use os dados para fazer perguntas melhores e apoiar o desenvolvimento.
</Callout>

<HelpImage alt="Visão 360 do mentorado" pendingId="M02.1" />
